export const ANALYTICS_SEGMENT_FLAG = "analytics.segment.enabled";
export const ANALYTICS_GTM_FLAG = "analytics.gtm.enabled";
export const ANALYTICS_EVENT_TRAFFIC_FLAG = "analytics.eventTraffic.enabled";
/** Shows the Consumer consent banner and privacy choice. Default off. */
export const ANALYTICS_CONSENT_UI_FLAG = "analytics.consentUi.enabled";
export const NEXT_PUBLIC_ANALYTICS_WRITE_KEY = "NEXT_PUBLIC_ANALYTICS_WRITE_KEY";
export const NEXT_PUBLIC_ANALYTICS_GTM_ID = "NEXT_PUBLIC_ANALYTICS_GTM_ID";
export const NEXT_PUBLIC_ANALYTICS_SEGMENT_ENABLED = "NEXT_PUBLIC_ANALYTICS_SEGMENT_ENABLED";
export const NEXT_PUBLIC_ANALYTICS_GTM_ENABLED = "NEXT_PUBLIC_ANALYTICS_GTM_ENABLED";
export const NEXT_PUBLIC_EVENT_TRAFFIC_ANALYTICS_ENABLED = "NEXT_PUBLIC_EVENT_TRAFFIC_ANALYTICS_ENABLED";
export const NEXT_PUBLIC_ANALYTICS_CONSENT_UI_ENABLED = "NEXT_PUBLIC_ANALYTICS_CONSENT_UI_ENABLED";
const defaultFeatureFlags = {
    [ANALYTICS_SEGMENT_FLAG]: false,
    [ANALYTICS_GTM_FLAG]: false,
    [ANALYTICS_EVENT_TRAFFIC_FLAG]: false,
    [ANALYTICS_CONSENT_UI_FLAG]: false,
};
// Next.js inlines only literal `process.env.NEXT_PUBLIC_*` member expressions.
// Indexing `process.env[key]` leaves the browser bundle fail-closed even when
// the static publish workflow set the variable.
function inlinedPublicAnalyticsEnv() {
    return {
        [NEXT_PUBLIC_ANALYTICS_WRITE_KEY]: process.env.NEXT_PUBLIC_ANALYTICS_WRITE_KEY,
        [NEXT_PUBLIC_ANALYTICS_GTM_ID]: process.env.NEXT_PUBLIC_ANALYTICS_GTM_ID,
        [NEXT_PUBLIC_ANALYTICS_SEGMENT_ENABLED]: process.env.NEXT_PUBLIC_ANALYTICS_SEGMENT_ENABLED,
        [NEXT_PUBLIC_ANALYTICS_GTM_ENABLED]: process.env.NEXT_PUBLIC_ANALYTICS_GTM_ENABLED,
        [NEXT_PUBLIC_EVENT_TRAFFIC_ANALYTICS_ENABLED]: process.env.NEXT_PUBLIC_EVENT_TRAFFIC_ANALYTICS_ENABLED,
        [NEXT_PUBLIC_ANALYTICS_CONSENT_UI_ENABLED]: process.env.NEXT_PUBLIC_ANALYTICS_CONSENT_UI_ENABLED,
    };
}
const readAnalyticsEnvironment = (source) => {
    const env = source ?? inlinedPublicAnalyticsEnv();
    return {
        writeKey: env[NEXT_PUBLIC_ANALYTICS_WRITE_KEY],
        gtmId: env[NEXT_PUBLIC_ANALYTICS_GTM_ID],
    };
};
const parseBoolean = (value) => {
    if (value === undefined) {
        return undefined;
    }
    return value.toLowerCase() === "true";
};
const readFeatureFlags = (source) => {
    const env = source ?? inlinedPublicAnalyticsEnv();
    return {
        ...defaultFeatureFlags,
        [ANALYTICS_SEGMENT_FLAG]: parseBoolean(env[NEXT_PUBLIC_ANALYTICS_SEGMENT_ENABLED]) ??
            defaultFeatureFlags[ANALYTICS_SEGMENT_FLAG],
        [ANALYTICS_GTM_FLAG]: parseBoolean(env[NEXT_PUBLIC_ANALYTICS_GTM_ENABLED]) ??
            defaultFeatureFlags[ANALYTICS_GTM_FLAG],
        [ANALYTICS_EVENT_TRAFFIC_FLAG]: parseBoolean(env[NEXT_PUBLIC_EVENT_TRAFFIC_ANALYTICS_ENABLED]) ??
            defaultFeatureFlags[ANALYTICS_EVENT_TRAFFIC_FLAG],
        [ANALYTICS_CONSENT_UI_FLAG]: parseBoolean(env[NEXT_PUBLIC_ANALYTICS_CONSENT_UI_ENABLED]) ??
            defaultFeatureFlags[ANALYTICS_CONSENT_UI_FLAG],
    };
};
const baseConfig = {
    serviceName: "project-x",
    apiBaseUrl: "https://api.project-x.example",
    featureFlags: defaultFeatureFlags,
};
export const loadConfig = (options = {}) => {
    const { overrides, env } = options;
    const envFeatureFlags = readFeatureFlags(env);
    const mergedFlags = {
        ...envFeatureFlags,
        ...(overrides?.featureFlags ?? {}),
    };
    const analytics = {
        ...readAnalyticsEnvironment(env),
        ...(overrides?.analytics ?? {}),
    };
    return {
        ...baseConfig,
        ...overrides,
        featureFlags: mergedFlags,
        analytics,
    };
};
export const isFeatureEnabled = (config, featureName) => {
    return config.featureFlags[featureName] ?? false;
};
export const getSegmentWriteKey = (config) => {
    return config.analytics.writeKey;
};
export const getGoogleTagManagerId = (config) => {
    return config.analytics.gtmId;
};
